import {useRouter} from 'next/router';
import {useCallback, useEffect, useState} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterRow from '@/src/Search/components/FilterRow';
import css from '@/src/Search/styles/JobTypesCheckboxes.module.css';
import fetchClinicsForFilter from '@/src/Search/utils/fetchClinicsForFilter';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

const FilterByClinics = () => {
  const [clinics, setClinics] = useState([]);

  const {query} = useRouter();
  // @ts-ignore
  const {setQueryFilters} = useSearchFilters();

  const getClinicsList = useCallback(async () => {
    const {responseBody} = await fetchClinicsForFilter();

    setClinics(responseBody.data);
  }, []);

  useEffect(() => {
    getClinicsList();
  }, []);

  const onChangeHandler = useCallback(
    (event) => {
      const value = event.target.value;

      const selected =
        (!!query[SEARCH_FILTERS.CLINIC_IDS] &&
          JSON.parse(query[SEARCH_FILTERS.CLINIC_IDS] as string)) ||
        [];

      if (selected.includes(value)) {
        const newValue = selected.filter((jobType) => jobType !== value);
        setQueryFilters({
          [SEARCH_FILTERS.CLINIC_IDS]: newValue.length
            ? JSON.stringify(newValue)
            : '',
        });
      } else {
        setQueryFilters({
          [SEARCH_FILTERS.CLINIC_IDS]: JSON.stringify([
            ...selected,
            event.target.value,
          ]),
        });
      }
    },
    [query]
  );

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'filters.employer'} />
        </Text>
      }
    >
      <FilterRow>
        <div className={css.checkboxesWrapper}>
          {clinics.map((clinic) => (
            <div className={css.checkboxes} key={clinic.id}>
              {/*@ts-ignore*/}
              <CheckboxCommon
                isOneLine
                id={clinic.organization_name}
                name={clinic.organization_name}
                value={clinic.id}
                label={clinic.organization_name}
                checked={
                  !!query[SEARCH_FILTERS.CLINIC_IDS] &&
                  JSON.parse(
                    query[SEARCH_FILTERS.CLINIC_IDS] as string
                  ).includes(`${clinic.id}`)
                }
                onChange={onChangeHandler}
              />
            </div>
          ))}
        </div>
      </FilterRow>
    </SimpleCollapse>
  );
};

export default FilterByClinics;
